var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam1White(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9511 17.9596C21.0185 17.9596 23.2444 16.4477 24.3882 13.5873C25.266 11.392 25.3844 8.80243 25.3844 6.55876C25.3844 2.45778 22.6056 0.00942993 17.9511 0.00942993C13.2966 0.00942993 10.5178 2.45771 10.5178 6.55876C10.5178 8.80243 10.6362 11.392 11.514 13.5873C12.6579 16.4477 14.8837 17.9596 17.9511 17.9596Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7097 19.8971H15.1497C9.82553 19.8971 5.49414 24.2286 5.49414 29.5526V30.2125C5.49414 33.3986 8.08614 35.9907 11.2723 35.9907H24.5871C27.7732 35.9907 30.3653 33.3986 30.3653 30.2125V29.5526C30.3652 24.2285 26.0338 19.8971 20.7097 19.8971Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6344 6.5587C27.6344 10.2999 27.2616 14.4016 24.7773 17.2624C25.3969 17.5054 26.0912 17.63 26.8549 17.63C29.1784 17.63 30.8643 16.4851 31.7305 14.3189C32.3746 12.708 32.4614 10.8297 32.4614 9.2047C32.4614 6.35409 30.6519 4.42056 27.3741 4.24084C27.5463 4.96921 27.6344 5.74392 27.6344 6.5587Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17543 17.6298C9.89978 17.6298 10.5621 17.5185 11.157 17.2997C8.64063 14.4352 8.26769 10.2957 8.26769 6.55851C8.26769 5.74682 8.35516 4.97486 8.52616 4.24881C5.50385 4.45947 3.56885 6.23029 3.56885 9.20444C3.56885 10.8294 3.65568 12.7078 4.29982 14.3187C5.16607 16.4849 6.85195 17.6298 9.17543 17.6298Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24415 29.5524C3.24415 25.2156 5.57522 21.4135 9.04999 19.3321H7.18523C3.22334 19.3321 0 22.5554 0 26.5174V26.9861C0 29.0438 1.40998 30.7781 3.31446 31.2741C3.23093 30.645 3.24415 30.2607 3.24415 29.5524Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8149 19.3321H26.8105C30.2848 21.4137 32.6153 25.216 32.6153 29.5524C32.6153 30.2541 32.6295 30.6567 32.5402 31.3084C34.5177 30.8644 36.0001 29.0957 36.0001 26.9861V26.5174C36.0001 22.5554 32.7768 19.3321 28.8149 19.3321Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam1White);
export default __webpack_public_path__ + "static/media/team1-white.14b0419a3373900ce45e4b18ee38abb2.svg";
export { ForwardRef as ReactComponent };